<template>
<!-- Modal para agregar horarios a la sucursal -->
  <section>
    <mdb-modal
      centered
      elegant
      scrollable
      size="lg"
      :show="mostrarModal"
      @close="$emit('cerrar', false); limpiarDatos()"
    >
    <mdb-modal-header class="pb-0">
        <mdb-modal-title>
          Agregar nuevo horario a la sucursal
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="row align-items-center">
          <div class="col-12 col-sm">
            <div :class="['my-2 p-0 md-form md-outline outline-select', validarCopyHorario.deDia]">
              <select
                v-model="copyHorario.deDia"
                id="rel-select"
                class="custom-select"
              >
                <option class="d-none" disabled value="">
                  Seleccione
                </option>
                <option
                  v-for="(dia, key) in dias"
                  :key="key"
                  :value="dia.value"
                >
                {{ dia.name }}
                </option>
              </select>
              <label
                for="rel-select"
                :class="copyHorario.dia ? 'label-active' : 'label-inactive'"
              >
                De
              </label>
            </div>
          </div>
          <div class="col-12 col-sm">
            <div :class="['my-2 p-0 md-form md-outline outline-select', validarCopyHorario.aDia]">
              <select
                v-model="copyHorario.aDia"
                id="rel-select"
                class="custom-select"
              >
                <option class="d-none" disabled value="">
                  Seleccione
                </option>
                <option
                  v-for="(dia, key) in dias"
                  :key="key"
                  :value="dia.value"
                >
                {{ dia.name }}
                </option>
              </select>
              <label
                for="rel-select"
                :class="copyHorario.dia ? 'label-active' : 'label-inactive'"
              >
                a
              </label>
            </div>
          </div>
          <div class="col-6 col-sm-2">
            <mdb-input
              v-model.trim="copyHorario.horaInicio"
              type="time"
              label="Recibe desde"
              class="my-2"
              :class="['my-2 type-time', validarCopyHorario.horaInicio]"
              :validation="validarCopyHorario.horaInicio == 'invalido'"
              outline
            />
          </div>
          <div class="col-6 col-sm-2">
            <mdb-input
              v-model.trim="copyHorario.horaFinal"
              type="time"
              label="Hasta"
              class="my-2"
              :class="['my-2 type-time', validarCopyHorario.horaFinal]"
              :validation="validarCopyHorario.horaFinal == 'invalido'"
              outline
            />
          </div>
          <div class="col-12 col-sm-auto">
            <mdb-btn
              flat
              dark-waves
              icon="plus"
              :class="['p-2', {'btn-bounce': displayCopyErrors || !horarios.length}]"
              @click="agregarHorarioDesdeHasta()"
            >
              Agregar
            </mdb-btn>
          </div>
        </div>
        <form id="form-horario" @submit.prevent>
          <div
            v-for="(horario, h) in horarios"
            :key="h"
            class="row align-items-center"
          >
            <div class="col-12 col-sm">
              <div :class="['my-2 p-0 md-form md-outline outline-select', validarValores[h].dia]">
                <select
                  v-model="horario.dia"
                  id="rel-select"
                  class="custom-select"
                >
                  <option class="d-none" disabled value="">
                    Seleccione
                  </option>
                  <option
                    v-for="(dia, key) in dias"
                    :key="key"
                    :value="dia.value"
                  >
                  {{ dia.name }}
                  </option>
                </select>
                <label
                  for="rel-select"
                  :class="horario.dia ? 'label-active' : 'label-inactive'"
                >
                  Dia
                </label>
              </div>
            </div>
            <div class="col-6 col-sm-3">
              <mdb-input
                v-model.trim="horario.horaInicio"
                type="time"
                label="Recibe desde"
                :class="['my-2 type-time', validarValores[h].horaInicio]"
                :validation="validarValores[h].horaInicio === 'invalido'"
                outline
              />
            </div>
            <div class="col-6 col-sm-3">
              <mdb-input
                v-model.trim="horario.horaFinal"
                type="time"
                label="Hasta"
                :class="['my-2 type-time', validarValores[h].horaFinal]"
                :validation="validarValores[h].horaFinal === 'invalido'"
                outline
              />
            </div>
            <div class="col-12 col-sm-auto">
              <mdb-btn
                flat
                dark-waves
                icon="trash"
                class="p-2"
                @click="eliminarHorario(h)"
              >
                <span class="d-sm-none">
                  Eliminar
                </span>
              </mdb-btn>
            </div>
          </div>
          <div class="text-center">
            <mdb-btn
              flat
              dark-waves
              @click="agregarOtroHorario()"
            >
              Agregar otro
            </mdb-btn>
          </div>
        </form>
        <mdb-modal-footer class="pt-2 pb-0 justify-content-center">
          <mdb-btn
            color="primario"
            class="p m-0"
            @click="guardarHorario()"
          >
            {{ accion == 'crear' ? 'Guardar horarios' : accion == 'editar' ? 'Actualizar horarios' : 'Eliminar'}}
          </mdb-btn>
        </mdb-modal-footer>
      </mdb-modal-body>
    </mdb-modal>
    <AlertaMensaje
      :alerta-mensaje="alertaMensaje"
      @cerrar="alertaMensaje.contenido = ''"
    />
  </section>
</template>
<script>
import {apiPost} from '@/funciones/api.js';
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbInput,
} from 'mdbvue';
import AlertaMensaje from '@/components/AlertaMensaje.vue';

export default {
  name: 'AgregarHorario',
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    AlertaMensaje,
  },
  props: {
    mostrarModal: {
      type: Boolean,
      required: true,
    },
    accion: {
      type: String,
      required: false,
    },
    horariosData: {
      type: Object,
      default: () => {},
      required: false,
    },
    sucId: {
      type: () => String | Number,
      required: false,
    },
  },
  data() {
    return {
      alertaMensaje: {contenido: ''},
      copyHorario: {
        deDia: '',
        aDia: '',
        horaInicio: '',
        horaFinal: '',
      },
      // validarCopyHorario: {},
      horarios: [],
      displayErrors: false,
      displayCopyErrors: false,
      dias: [
        {name: 'Lunes', value: '0'},
        {name: 'Martes', value: '1'},
        {name: 'Miércoles', value: '2'},
        {name: 'Jueves', value: '3'},
        {name: 'Viernes', value: '4'},
        {name: 'Sábado', value: '5'},
        {name: 'Domingo', value: '6'},
      ],
    };
  },
  computed: {
    validarValores() {
      if (this.displayErrors && (this.horarios.length && Object.keys(this.horarios[0]).length > 1)) {
        return this.horarios.map((horario) => ({
          dia: !!horario.dia.length ? 'valido' : 'invalido',
          horaInicio: !!horario.horaInicio ? 'valido' : 'invalido',
          horaFinal: !!horario.horaFinal || horario.horaInicio < horario.horaFinal ? 'valido' : 'invalido',
        }));
      };
      return this.horarios.map(() => ({
        dia: '',
        horaInicio: '',
        horaFinal: '',
      }));
    },
    validarCopyHorario() {
      if (this.displayCopyErrors) {
        return {
          deDia: !!this.copyHorario.deDia.length ? '' : 'invalido',
          aDia: !!this.copyHorario.aDia.length ? '' : 'invalido',
          horaInicio: !!this.copyHorario.horaInicio ? '' : 'invalido',
          horaFinal: !!this.copyHorario.horaFinal || this.copyHorario.horaInicio < this.copyHorario.horaFinal ? '' : 'invalido',
        };
      };
      return {
        deDia: '',
        aDia: '',
        horaInicio: '',
        horaFinal: '',
      };
    },
  },
  methods: {
    agregarOtroHorario() {
      this.horarios.push(
          {
            dia: '',
            horaInicio: '',
            horaFinal: '',
            suc: this.sucId,
            obs: '',
          },
      );
    },
    agregarHorarioDesdeHasta() {
      this.displayCopyErrors = true;
      if (!Object.values(this.copyHorario).filter((h) => !h.length).length) {
        this.dias.forEach((dia, d) => {
          if (Number(dia.value) <= this.copyHorario.aDia && Number(dia.value) >= this.copyHorario.deDia) {
            this.horarios.push(
                {
                  dia: dia.value,
                  horaInicio: this.copyHorario.horaInicio,
                  horaFinal: this.copyHorario.horaFinal,
                  suc: this.sucId,
                  obs: '',
                },
            );
          }
        });
        this.copyHorario = {
          deDia: '',
          aDia: '',
          horaInicio: '',
          horaFinal: '',
        };
        this.displayCopyErrors = false;
      } else {
        this.alertaMensaje = {
          contenido: 'Debes llenar todos los datos para agregar el horario.',
          tipo: 'advertencia',
        };
      }
    },
    eliminarHorario(horario) {
      this.horarios.splice(horario, 1);
    },
    guardarHorario() {
      this.displayErrors = true;
      if (Object.values(this.copyHorario).filter((h) => h.length).length) {
        this.displayCopyErrors = true;
        if (Object.values(this.validarCopyHorario).filter((h) => h == 'invalido').length) {
          this.alertaMensaje = {
            contenido: 'Rellena los datos y presiona el botón de agregar antes de guardar.',
            tipo: 'advertencia',
          };
        }
      } else if (!this.validarValores.filter((horario) => Object.values(horario).includes('invalido')).length) {
        if (!this.horarios.length) this.horarios.push({suc: this.sucId});
        apiPost({s: 'horariosModificarMv'}, JSON.stringify(this.horarios))
            .then((r) => {
              if (r.data.r) {
                this.alertaMensaje = {
                  contenido: r.data.e,
                  tipo: 'correcto',
                };
                this.$emit('guardado', false);
                this.limpiarDatos();
                return;
              }
              this.alertaMensaje = {
                contenido: `Ocurrió un error: ${response.data.e}`,
                tipo: 'error',
              };
            }).then(() => {
              this.displayErrors = false;
              this.displayCopyErrors = false;
            })
            .catch(() => {
              this.alertaMensaje = {
                contenido: 'Ha ocurrido un error modificando los horarios al cliente, por favor intenta de nuevo',
                tipo: 'advertencia',
              };
            });
      } else {
        this.alertaMensaje = {
          contenido: 'Rellena los datos y presiona el botón de agregar antes de guardar.',
          tipo: 'advertencia',
        };
      }
    },
    limpiarDatos() {
      this.copyHorario = {
        deDia: '',
        aDia: '',
        horaInicio: '',
        horaFinal: '',
      };
      this.displayCopyErrors = false;
      this.displayErrors = false;
      this.horarios = [];
    },
  },
  watch: {
    horariosData: function(value) {
      if (!value) return;
      Object.keys(this.horariosData).forEach((key) => {
        this.horariosData[key].forEach((hor) => {
          this.horarios.push({
            id: hor.id_hor,
            dia: hor.num_dia_hor,
            horaInicio: hor.hor_ini_hor,
            horaFinal: hor.hor_fin_hor,
            suc: this.sucId,
            obs: hor.obs_hor,
          });
        });
      });
    },
  },
};
</script>

<style>
.btn-bounce {
  transition: all .5 ease;
  animation: btn-bounce 2s infinite;
}
@keyframes btn-bounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
